import { Component, OnInit, Input } from '@angular/core';
import {IReportItemComponent} from "../../models/i-report-item-component";
import { AssessmentResult } from "../../../shared/models/assessment-result";
import { ScaleResult } from "../../../shared/models/scale-result";
import { Scale } from "../../../shared/models/scale";
import { AssessmentHydrator } from "../../../shared/services/assessment-hydrator.service";
import { Variable } from "../../models/variable";
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';

interface Computation {
  assessmentUid:string;
  scaleId:string;
}

@Component({
  selector: 'app-computed-scale',
  templateUrl: './computed-scale.component.html'
})
export class ComputedScaleComponent extends BaseReportItemComponent implements OnInit, IReportItemComponent {

  private _scaleResult:ScaleResult;
  private _assessmentsUids:string[];
  private _calculation:string;
  @Input("data") public data:any;
  @Input("data") public results:AssessmentResult[];

  constructor(private hydrator:AssessmentHydrator) { 
    super();
  }

  public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
    this._scaleResult = new ScaleResult();
    if (data) {
      if (data.scale) {
        this._scaleResult.scale = this.hydrator.hydrateScale(data.scale);
      }
      // calculation, assessments
      this._calculation = data.calculation || "SUM";
      if (data.items) {
        data.items.forEach(i => this.addCalculation(i))
        this._scaleResult.range = this._scaleResult.scale.getRangeForScore(this._scaleResult.score);
      }
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  public get scaleResult() {
    return this._scaleResult;
  }

  private addCalculation(item:Computation) {
    let result = this.results.find(r => r.assessment.uid == item.assessmentUid);
    let scaleResult = result ? result.scaleResults.find(sr => sr.scale.id == item.scaleId) : null;
    if (!(result && scaleResult)) {
      return;
    }
    if (this._calculation === "SUM") {
      this._scaleResult.score += scaleResult.score;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/computed-scale/computed-scale.component.ts